var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
function SvgClock(passedProps, svgRef) {
    var props = __assign({}, passedProps);
    return (React.createElement("svg", __assign({ width: "1.5em", height: "1.5em", viewBox: "0 0 31 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", color: "currentColor", ref: svgRef }, props),
        React.createElement("path", { d: "M25.122 12c0-3.469-1.875-6.656-4.875-8.438-3.047-1.734-6.75-1.734-9.75 0C7.45 5.345 5.622 8.532 5.622 12c0 3.516 1.828 6.703 4.875 8.484 3 1.735 6.703 1.735 9.75 0 3-1.78 4.875-4.968 4.875-8.484zm-21.75 0a11.91 11.91 0 016-10.36c3.703-2.156 8.25-2.156 12 0 3.703 2.157 6 6.094 6 10.36 0 4.313-2.297 8.25-6 10.406-3.75 2.157-8.297 2.157-12 0-3.75-2.156-6-6.093-6-10.406zm10.875-6.375c0-.61.469-1.125 1.125-1.125.61 0 1.125.516 1.125 1.125v5.813l3.984 2.624c.516.376.657 1.079.329 1.594-.375.516-1.079.656-1.594.281l-4.5-3c-.281-.187-.469-.562-.469-.937V5.625z", fill: "#242B42" })));
}
var ForwardRef = React.forwardRef(SvgClock);
export default ForwardRef;
